import { API_BASE_URL } from "@kupikupi/brand";
import { useQuery } from "@tanstack/react-query";
import { listFeaturedHome } from "../endpoints/featured";

interface UseFeaturedHomeOptions {
  authScope?: string | null;
  enabled?: boolean;
}

export function useFeaturedHome(options: UseFeaturedHomeOptions = {}) {
  return useQuery({
    queryKey: ["featured", "home", options.authScope ?? "anonymous"],
    queryFn: () => listFeaturedHome({ baseUrl: API_BASE_URL }),
    enabled: options.enabled ?? true,
    staleTime: 5 * 60 * 1000,
  });
}
